import { SearchResultItem } from '../../globalSearch.types';
import AccountReceivableRow from './renderers/AccountReceivableRow/AccountReceivableRow';
import CatalogRow from './renderers/CatalogRow/CatalogRow';
import CustomerRow from './renderers/CustomerRow/CustomerRow';
import InvoiceRow from './renderers/InvoiceRow/InvoiceRow';
import OrderRow from './renderers/OrderRow/OrderRow';
import ProductRow from './renderers/ProductRow/ProductRow';
import { GlobalSearchItemActions } from './resultRow.types';

interface ResultRowProps {
  item: SearchResultItem;
  query: string;
  isActive?: boolean;
  isDisabled?: boolean;
  domId?: string;
  onSelect: () => void;
  itemActions?: GlobalSearchItemActions;
}

function ResultRow({
  item,
  query,
  isActive,
  isDisabled,
  domId,
  onSelect,
  itemActions,
}: ResultRowProps) {
  const rendererProps = { query, isActive, isDisabled, domId, onSelect, itemActions };

  switch (item.entityType) {
    case 'product':
      return <ProductRow item={item} {...rendererProps} />;
    case 'order':
      return <OrderRow item={item} {...rendererProps} />;
    case 'customer':
      return <CustomerRow item={item} {...rendererProps} />;
    case 'catalog':
      return <CatalogRow item={item} {...rendererProps} />;
    case 'invoice':
      return <InvoiceRow item={item} {...rendererProps} />;
    case 'accountReceivable':
      return <AccountReceivableRow item={item} {...rendererProps} />;
    default:
      return null;
  }
}

export default ResultRow;
